import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-text-viewer',
  templateUrl: './text-viewer.component.html',
  styleUrls: ['./text-viewer.component.scss']
})
export class TextViewerComponent implements OnChanges {
  static readonly MAX_CHARS = 500_000;

  @Input() blob: Blob | null = null;

  text = '';
  loading = false;
  error: string | null = null;
  truncated = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['blob']) this.read();
  }

  private async read(): Promise<void> {
    if (!this.blob) {
      this.text = '';
      return;
    }
    this.loading = true;
    this.error = null;
    this.truncated = false;
    try {
      const raw = await this.blob.text();
      if (raw.length > TextViewerComponent.MAX_CHARS) {
        this.text = raw.substring(0, TextViewerComponent.MAX_CHARS);
        this.truncated = true;
      } else {
        this.text = raw;
      }
    } catch (e: any) {
      this.error = e?.message ?? 'No se pudo leer el archivo.';
    } finally {
      this.loading = false;
    }
  }
}
